import React from "react";
import "../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/UpcomingMeetings.style.css";
import ScrollableShortCard from "../../../../Universal/ScrollableShortCard.component";
import UpcomingEventsCard from "../Activities/UpcomingEventsCard.component";
const UpcomingMeetings = ({ meetingsData }) => {
  return (
    <ScrollableShortCard title="Upcoming meetings">
      {meetingsData &&
        meetingsData.map((data, index) => (
          <UpcomingEventsCard
            key={index}
            eventDate={data.meetingDate}
            eventName={data.meetingName}
            designation={data.meetingAttendee}
          />
        ))}
    </ScrollableShortCard>
  );
};

export default UpcomingMeetings;
